import React, { ReactNode } from 'react';
import { clamp } from '../../utils/reelMath';
interface Segment {
  text: string;
  className?: string;
}
interface TypeTextProps {
  segments: Segment[] | string;
  time: number;
  start: number;
  /** Characters per second. */
  cps?: number;
  className?: string;
  caretClassName?: string;
  /** Keep the caret blinking after typing (for the line that holds). */
  holdCaret?: boolean;
}

/**
 * Typewriter text driven by the reel clock. Untyped characters stay in the layout
 * (transparent) so centered or wrapping text never shifts while typing.
 * Characters are split by code point so emoji type as one character.
 */
export function TypeText({
  segments,
  time,
  start,
  cps = 14,
  className = '',
  caretClassName = 'bg-ink',
  holdCaret = false
}: TypeTextProps) {
  const segs = (typeof segments === 'string' ? [{
    text: segments
  }] : segments).map(s => ({
    ...s,
    chars: Array.from(s.text)
  }));
  const total = segs.reduce((n, s) => n + s.chars.length, 0);
  const typed = Math.floor(clamp((time - start) * cps, 0, total));
  const typingEnd = start + total / cps;
  const showCaret = time >= start - 0.4 && (holdCaret || time < typingEnd + 0.9);
  const typing = time >= start && time < typingEnd;
  const caretOn = typing || Math.floor(time * 2.4) % 2 === 0;
  const caret = <span className="relative inline-block w-0" aria-hidden="true" data-id="element-312" data-mp="tjq8gwxhagq8">
      <span className={`absolute bottom-[-0.12em] left-[0.04em] h-[0.9em] w-[0.035em] min-w-[2px] ${caretClassName}`} style={{
      opacity: showCaret && caretOn ? 1 : 0
    }} data-id="element-313" data-mp="3s36x8jftrof6" />
    </span>;
  let remaining = typed;
  let caretPlaced = false;
  const nodes: ReactNode[] = segs.map((seg, i) => {
    const count = clamp(remaining, 0, seg.chars.length);
    remaining -= count;
    const placeHere = !caretPlaced && count < seg.chars.length;
    if (placeHere) caretPlaced = true;
    return <span key={i} className={seg.className} data-id="element-314" data-mp="3ea8nfs2mxts3" data-mpi={i}>
        {seg.chars.slice(0, count).join('')}
        {placeHere && caret}
        <span className="opacity-0" data-id="element-315" data-mp="368zx0z2141y0">{seg.chars.slice(count).join('')}</span>
      </span>;
  });
  return <span className={className} data-id="element-316" data-mp="31b7w5fjep5ho">
      {nodes}
      {!caretPlaced && caret}
    </span>;
}